export default __webpack_public_path__ + "static/portfolio-mas-16-094689b971661f512b23e85ff7e4a897.jpg";